module.exports = __webpack_public_path__ + "static/fonts/Robotomediumitalic.05f1613.woff";